import { yup, yupResolver } from '@sahinyazilim/sahinyazilim-components';

export const SettingFormYup = yupResolver<any>(
  yup
    .object({
      logo: yup.string(),
      contact: yup.object(),
      socialMedia: yup.object(),
    })
    .required(),
);
